import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { HeaderBannerProps } from '..';

const useStyles = makeStyles({ name: 'DesktopHeaderBanner' })(({ Skoda: { settings: { headerBanner } } }) => ({
	root: {
		position: 'relative',
		overflow: 'hidden'
	},
	image: {
		width: '100%',
		height: 'auto'
	},
	gradient: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		background: `linear-gradient(96.79deg, ${headerBanner.color} 0.28%, rgba(0, 0, 0, 0) 54.54%)`
	},
	content: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center'
	}
}));

export const DesktopHeaderBanner: React.FC<HeaderBannerProps> = (props) => {
	const { children, img, onImageLoad } = props;
	const { classes: styles } = useStyles(undefined, { props });
	const images: string[] = typeof (img) === 'string' ? [img] : img;
	const [defaultImg, ...other] = images;

	return (
		<div data-test='header-banner-desktop'
			className={styles.root}>
			<picture>
				{other.map(anotherFormatImage =>
					<source srcSet={anotherFormatImage} type={`image/${anotherFormatImage.split('.').pop()}`} />)}
				<img width={2560} height={933} className={styles.image} src={defaultImg} alt='banner' onLoad={onImageLoad} />
			</picture>
			<div className={styles.gradient} />
			<div className={styles.content}>
				{children}
			</div>
		</div>
	);
};
